import http from '../../shared/http.js';
import { withFlash } from '../../shared/flash.js';
import { initFormModalLinks } from '../../shared/formModal.js';
import { confirmAction, hideLoading, notifyError, showLoading } from '../../shared/notify.js';

// What each row button does, so the handler below stays a lookup rather than a
// chain of ifs. Only deletion exists for now - a lookup row has no status to
// toggle, since `aktiv` is edited on the form - but the shape matches
// userList.js so a later action is one entry.
const ACTIONS = {
  delete: {
    confirm: (name) => ({
      title: 'Eintrag löschen',
      message: `Möchten Sie ${name} endgültig löschen? Das kann nicht rückgängig gemacht werden.`,
      okText: 'Löschen'
    }),
    loading: 'Eintrag wird gelöscht …',
    flash: 'stammdaten-geloescht',
    run: (id) => http.delete(`/stammdaten/${id}`)
  }
};

export function initStammdatenList() {
  const list = document.getElementById('stammdaten-list');
  if (!list) return;

  // Creating and editing happen in the shared dialog rather than on their own
  // page. The links keep their href, so a middle click still opens the real
  // page and nothing breaks with the bundle absent - initFormModalLinks only
  // intercepts a plain left click.
  //
  // Delegated from document, because the "create" button sits in the page
  // header rather than inside the table.
  initFormModalLinks({
    selector: 'a[href$="/new"], a[href$="/edit"]',
    // No live refresh on this list yet, so the page reload is what shows the
    // change - the same round trip it did before, minus the one it used to
    // take to reach the form.
    onSaved: () => window.location.reload()
  });

  // One delegated listener for the whole table, so rows cost nothing to add.
  list.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-action]');
    if (!button) return;

    const action = ACTIONS[button.dataset.action];
    if (!action) return;

    const { stammdatenId, stammdatenName } = button.dataset;

    if (action.confirm && !(await confirmAction(action.confirm(stammdatenName)))) return;

    button.disabled = true;
    showLoading(action.loading);

    try {
      await action.run(stammdatenId);
      // Back to the list for the type currently on screen, which is where the
      // browser already is - the flash key is the only thing that changes.
      window.location.href = withFlash(window.location.pathname, action.flash);
    } catch (err) {
      hideLoading();
      button.disabled = false;
      notifyError(
        err.response?.data?.message || 'Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut.'
      );
    }
  });
}
